import { useQuery } from 'react-query'
import { useSnackbar } from 'notistack'
import { getBanners } from 'services/cm-api/get-banners'

/**
 * Loads every non-deleted banner. Gated on the Firebase access
 * token the same way useCustomerGroups is — without it the CMAPI
 * would 401 on every mount.
 */
export function useBanners() {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(['getBanners'], () => getBanners(), {
    enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
    onError: (err) => {
      enqueueSnackbar('Cannot get banners', { variant: 'error' })
      console.error('getBanners failed: ', err)
    },
  })
}
